<template lang="pug">
  .color-swatch
    .color(:style="{backgroundColor: color}")
</template>

<script>

export default {
  name: 'ColorSwatch',
  components: {
  },
  props: {
    color: String
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
  .color-swatch
    //border $border-default

    height 30px
    //padding 1px
    width 30px
    .color
      height 100%
      width 100%
</style>
